import TransactionsForFundraisingDatagrid from '../DatagridEntity/TransactionsForFundraisingDatagrid';

const FundraisingTransactionsPage = () => (<TransactionsForFundraisingDatagrid />);
export default FundraisingTransactionsPage;
